import { apiClient } from '@shared/api';
import type { ApiResponse } from '@shared/types';
import type { FreightLocationDto } from '../types';

class FreightService {
  private readonly baseUrl = '/freight';

  async getLocations(): Promise<FreightLocationDto[]> {
    const { data } = await apiClient.get<ApiResponse<FreightLocationDto[]>>(
      `${this.baseUrl}/locations`,
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to load freight locations');
  }

  async getLocationById(id: string): Promise<FreightLocationDto> {
    const { data } = await apiClient.get<ApiResponse<FreightLocationDto>>(
      `${this.baseUrl}/locations/${encodeURIComponent(id)}`,
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Freight location not found');
  }
}

export const freightService = new FreightService();
